ACC.mycompany = {
  bindAll: function() {
    var isResendClicked = false,
        userRowTooltip = 'ph-mycompany__usersrow-tooltip';

    $(document).on('click', '.ph-disableuser', function() {
      var userid = $(this).parent().find('.ph-userid-for-disabel').text();


      ACC.mycompany.disableUsers(userid, $(this));
    });

    $(document).on('click', '.ph-resendmail', function() {
      if ($('.ph-loginRedirectToggle').length === 0) {
        var userid = $(this).parent().find('.ph-userid-for-resendmail').text();

        ACC.mycompany.resendMail(userid);

        $(document).find('.' + userRowTooltip).addClass('hidden');

        isResendClicked = true;
      }
    });

    $(document).on('click', '.ph-reactivate_user', function() {
      var userid = $(this).parent().find('.ph-userid-for-disabel').text();


      ACC.mycompany.reactivatedUsers(userid, $(this));
    });
    $(document).on('click', '.ph-mycompany__usersrow-dots', function() {
      if (!isResendClicked) {
        $('.' + userRowTooltip).addClass('hidden');
        $(this).find('.' + userRowTooltip).toggleClass('hidden');
        $('.ph-headerarent__tooltipmobile').toggleClass('hidden');
      }

      isResendClicked = false;
    });
    $('body,html').click(function(e) {
      if ($(e.target).closest('.ph-mycompany__usersrow-dots').length === 0 && $(e.target).closest('.' + userRowTooltip).length === 0) {
        $('.' + userRowTooltip).addClass('hidden');
      }
    });
  },

  disableUsers: function(userid, $obj) {
    $.ajax({
      dataType: 'json',
      async: false,
      url: $('.ph-disableUserUrl').text(),
      type: 'POST',
      data: {
        user: userid
      },
      success: function(result) {
        if (result.uid === userid) {
          var selectedid = result.uid,
              deletedtext = $('.ph-manageusers_deletedtext').text();

          $('.ph-mycompany__usersrow').find('div[data-email=\'' + selectedid + '\']').html(deletedtext);
          $obj.parents().siblings('.ph-deleteoption').removeClass('hidden');
          $obj.parents('.ph-activeoption').addClass('hidden');
        }
      }
    });
  },
  resendMail: function(userid) {
    $.ajax({
      type: 'POST',
      url: $('.ph-resendMailUrl').text(),
      dataType: 'json',
      async: false,
      data: {
        user: userid
      }
    });
  },
  reactivatedUsers: function(userid, $obj) {
    $.ajax({
      type: 'POST',
      url: $('.ph-reactivatedUsersUrl').text(),
      dataType: 'json',
      async: false,
      data: {
        user: userid
      },
      success: function(result) {
        if (result.uid === userid) {
          var selectedid = result.uid,
              activetext = $('.ph-manageusers_activetext').text();

          $('.ph-mycompany__usersrow').find('div[data-email=\'' + selectedid + '\']').html(activetext);
          $obj.parents('.ph-deleteoption').addClass('hidden');
          $obj.parents().siblings('.ph-activeoption').removeClass('hidden');
        }
      }
    });
  }
};

$(document).ready(function() {
  ACC.mycompany.bindAll();
});


